import { render, staticRenderFns } from "./reviewDialog.vue?vue&type=template&id=0e1f8cb6&scoped=true&"
import script from "./reviewDialog.vue?vue&type=script&lang=js&"
export * from "./reviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./reviewDialog.vue?vue&type=style&index=0&id=0e1f8cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1f8cb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1f8cb6')) {
      api.createRecord('0e1f8cb6', component.options)
    } else {
      api.reload('0e1f8cb6', component.options)
    }
    module.hot.accept("./reviewDialog.vue?vue&type=template&id=0e1f8cb6&scoped=true&", function () {
      api.rerender('0e1f8cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/revenueSsharing/components/reviewDialog.vue"
export default component.exports